export default __webpack_public_path__ + "static/V-ISO_Liian_korkea_ISO-ea9d13874ad1b4e68470ba0d5e7a9851.jpg";